<template>
  <div class="user-container" ref="usercontainer">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
      ><a href="javascript:;">文章管理</a>
      </el-breadcrumb-item>
      <el-breadcrumb-item>文章修改</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card" style="margin-top: 20px;height:100%;overflow-y: scroll" >
      <el-form ref="form"  label-width="80px" >
        <el-form-item label="标题" style="width:60%;" >
          <el-input v-model="form.title"></el-input>
        </el-form-item>

        <el-form-item label="所在栏目">
          <el-select v-model="formParentChild" placeholder="请选择活动区域" @change="getColumn(formParentChild)" >
            <el-option v-for="item in parentColumnList" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="form.columnId" placeholder="请选择活动区域" style="z-index: 9999">
            <el-option v-for="item in formColumnChild" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  label="文章来源"   style="width:20%;">
          <el-input  placeholder="请输入文章来源" v-model="form.source"></el-input>
        </el-form-item>
        <el-form-item label="作者"  style="width:20%;">
          <el-input  placeholder="请输入作者"  v-model="form.writer"></el-input>
        </el-form-item>

        <el-form-item label="封面图">
          <div style="float: left" v-if="imgVisible">
            <div class="el-upload-list el-upload-list--picture-card">
              <div class="el-upload-list__item is-success">
                <img :src="form.imgsrc" style="width:100%;height: 100%">
                <span class="el-upload-list__item-actions" >
                  <span class="el-upload-list__item-preview" @click="deleteImg()" >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </div>
          </div>

          <el-upload
              action="/api/common/upload"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="handSuccess"
              list-type="picture-card"
              :limit = 1
              :multiple = false
              v-if="imgUploadVisible"
          >
            <i class="el-icon-plus" ></i>


            <span v-if="!disabled"
                class="el-upload-list__item-delete"

            >
              <i class="el-icon-download"></i>
            </span>
          </el-upload>

        </el-form-item>
        <el-form-item label="正文">
          <WangEditor @change="changeWang" :value="form.content"></WangEditor>

          <el-button type="primary" style="margin-top: 20px;" @click="articleSubmit(form)">提交</el-button>
          <el-button type="warning" style="margin-top: 20px;" @click="restPage()">重置</el-button>
          <el-button type="danger" style="margin-top: 20px;" @click="offPage()">取消</el-button>
        </el-form-item>

      </el-form>
    </el-card>
  </div>
</template>

<script>
import {request} from "@/request/request";
import WangEditor from "@/components/WangEditor";


export default {
  name: "ArticleUpdateAdmin",
  components:{
    WangEditor,
  },
  data() {
    return {
      form: {
        title: '',
        content:'',
        source: '',
        writer: '',
        columnId: '',
        imgsrc:''

      },
      parentColumnList:[
        {name:'红色教育服务中心',id:0},
        {name:'东北抗日义勇军纪念馆',id:1},
        {name:'李秋实纪念馆',id:2},
        {name:'桓仁抗战红都教育服务中心',id:3}
      ],
      formParentChild:"",
      formColumnChild:[],
      dialogTableVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      dialogImageUrl: '',
      dialogVisible: false,
      restfulUrl:'articles',//获取全部列表
      disabled:true,
      imgVisible:false,
      imgUploadVisible:false
    }
  },
  methods:{
    changeWang(html){
      //这里的html是带有标签的
      this.form.content=html
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.form.imgsrc = file.url;
      this.dialogVisible = true;
    },
    handSuccess(response){
      this.form.imgsrc = response.data;
      this.imgUploadVisible = false;
      this.imgVisible = true;
    },
    articleSubmit:function(form){
      this.updateOneById(form);
      this.$router.push({name:'articleman'});
    },
    restPage(){
      this.form =  {
            title: '',
            content:'',
            source: '',
            writer: '',
            columnId: '',
            imgsrc:''
      }
    },
    deleteImg:function(){
      this.imgVisible = false;
      this.imgUploadVisible = true;
      this.form.imgsrc = '';
    },
    offPage(){
      this.$router.push({name:'articleman'});
    },
    getColumn(data){
      var getChild = {id:data};
      this.getChildData(getChild);
    },
    getChildData:function(data){//获取全部数据
      request({
        method:'POST',
        url:"/acolumns/parentid",
        data:data,
      }).then(res =>{
        this.formColumnChild = res.data[0].parentId;
      },err=>{
        console.log(err)
      })
    },

    updateOneById:function(data){
      request({
        method:'PUT',
        url:'/articles',
        data:data
      }).then(res =>{
        if(res.code==1){
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
        }
      },err=>{
        console.log(err)
      })
    },
    getOneByID:function(uid){
      request({
        method:'GET',
        url:this.restfulUrl+'/'+uid,
      }).then(res =>{
        if(res.code==1){
          this.getColumn(res.data.columnId);
          this.form = res.data;
        }
        if(res.data.imgsrc){
          this.imgVisible = true;
        }
      },err=>{
          console.log(err)
      })
    },
  },
  mounted(){
    this.getOneByID(this.$route.params.id)
  },
  created() {

  }
}
</script>

<style scoped>
.user-container{
  max-height:100%;
  text-align: left;

}
</style>
